<template>
    <div v-if="showCheckbox" class="c-checkbox-item"></div>
    <div v-if="false" class="c-checkbox-item">
        <div class="checkbox">
            <label>
                <input
                    :disabled="isFinalizingOrder"
                    type="checkbox"
                    @change="selectCar"
                    v-bind:checked="isSelected"
                />
                <i
                    :style="
                        isFinalizingOrder
                            ? 'background: transparent; cursor: not-allowed'
                            : isSelected
                            ? ''
                            : 'background: white'
                    "
                />
            </label>
        </div>
    </div>
    <div v-if="isLoading" />
    <tr
        v-else
        :class="`dashboard__table-tr dashboard__table-order
        ${orderStatusClass[String(order?.status)]} ${
            !isOrderInStatus(orderStatusEnum.to_pay) && isFinalizingOrder ? 'pending' : ''
        }
        ${isSelected ? 'c-table-item-selected' : ''}
        ${showDocuments ? 'show-documents' : ''}`"
        role="row"
    >
        <td
            v-if="orderStatus === String('to_approve') || orderStatus === '1'"
            class="dashboard__table-td--b dashboard__table-td--approve"
        >
            <div class="dashboard__table-column">
                <button disabled class="to-approve-button">
                    <i18n-t keypath="myOrders.to_approve.title" />
                </button>
                <span
                    v-if="[3].includes(order.status.id)"
                    class="status-text status-text--bold"
                >
                    {{ order.status.name }}
                </span>
                <span
                    v-if="[1, 2].includes(order.status.id)"
                    class="status-text status-text--bold"
                >
                    {{ order.status.name }}
                </span>
                <span
                    v-if="order.status.id === 1"
                    class="status-text"
                    style="white-space: break-spaces"
                >
                    <i18n-t keypath="myOrders.transport_and_administration_fees" />
                </span>
            </div>
        </td>
        <td
            v-if="orderStatus === String('on_order') || orderStatus === '2'"
            class="dashboard__table-td"
            style="border-left: 5px solid rgba(255, 165, 114, 1); padding-left: 20px"
        >
            <div>
                <button disabled class="on-order-button disabled">
                    <i18n-t keypath="myOrders.on_order.title" />
                </button>
            </div>
        </td>
        <td
            v-if="orderStatus === String('to_pay') || orderStatus === '3'"
            class="dashboard__table-td dashboard__table-td--pay"
        >
            <div class="dashboard__table-column">
                <template v-if="counters.allPayProcessingPayment > 0">
                    <button disabled class="to-pay-button">
                        <i18n-t keypath="myOrders.to_pay.title" />
                    </button>
                </template>
                <template v-else-if="counters.filteredPayProcessingPayment > 0">
                    <button disabled class="to-pay-status">
                        <i18n-t keypath="myOrders.processing_payment.title" />
                    </button>
                </template>
                <template v-if="counters.allPayProcessingPayment > 0">
                    <div class="flex flex-col m-9">
                        <span class="status-text status-text--bold">
                            <i18n-t keypath="myOrders.prePaid" />
                            :
                        </span>
                        <span class="status-text">
                            <app-format-currency
                                :value="orderPaymentDto?.amount_paid_confirmed"
                                currency="EUR"
                            />
                        </span>
                    </div>
                    <div class="flex flex-col">
                        <span
                            class="status-text"
                            v-if="counters.filteredPayAwaitingPayment > 0"
                        >
                            <i18n-t keypath="dashboard.myAccountComponent.companyInfoTab.teamMembers.awaiting_payment"/>:
                            {{ counters.filteredPayAwaitingPayment }}
                        </span>
                        <!-- <span
                            class="status-text"
                            v-if="counters.filteredPayProcessingPayment"
                        > -->
                        <!-- duplicate "Processing payment" -->
                        <!-- Processing payment:
                            {{ counters.filteredPayProcessingPayment }} -->
                        <!-- </span>  -->
                    </div>
                </template>
                <template v-if="counters.filteredPayProcessingPayment > 0">
                    <div class="flex flex-col m-9">
                        <span class="status-text">
                            <i18n-t keypath="dashboard.myAccountComponent.companyInfoTab.teamMembers.processing_payment"/>:
                            {{ counters.filteredPayProcessingPayment }}
                        </span>
                    </div>
                </template>
            </div>
        </td>
        <td
            v-if="orderStatus === String('to_transport') || orderStatus === '4'"
            class="dashboard__table-td dashboard__table-td--transport"
        >
            <div>
                <button disabled class="to-transport-button">
                    <i18n-t keypath="myOrders.to_transport.title" />
                </button>
            </div>
            <div class="status-text m-9">
                <div v-if="openTransportPlanningInfo">
                    <span>
                        <i18n-t keypath="myOrders.planning_ongoing" />
                        :{{ counters.planningOnGoing }}
                    </span>
                    <br />
                    <span>
                        <i18n-t keypath="myOrders.transport_planned" />
                        : {{ counters.transportPlanned }}
                    </span>
                </div>
                <div v-else-if="openPickupDateReadyForPickupInfo">
                    <span>
                        <i18n-t keypath="dashboard.myAccountComponent.companyInfoTab.teamMembers.awaiting_pickup_date"/>:
                        {{ counters.transportAwaitingPickupDate }}
                    </span>
                    <br />
                    <span>
                        <i18n-t keypath="myOrders.ready_for_pickup" />
                        : {{ counters.transportReadyForPickup }}
                    </span>
                </div>
            </div>
        </td>
        <td
            v-if="orderStatus === String('processing_documents') || orderStatus === '5'"
            class="dashboard__table-td dashboard__table-td--process"
        >
            <div class="dashboard__table-column">
                <button disabled class="processing-documents-button">
                    <i18n-t keypath="myOrders.processing_documents.title" />
                </button>
                <span
                    v-if="openProcessingDocInfo"
                    class="status-text"
                    style="white-space: break-spaces"
                >
                    <i18n-t keypath="dashboard.myAccountComponent.companyInfoTab.teamMembers.your_car_documents"/>
                </span>
            </div>
        </td>
        <td
            v-if="orderStatus === String('completed') || orderStatus === '6'"
            class="dashboard__table-td dashboard__table-td--completed"
        >
            <div class="dashboard__table-column">
                <button disabled class="completed-button">
                    <i18n-t keypath="myOrders.completed.title" />
                </button>
                <div class="status-text">
                    <b>
                        <i18n-t keypath="myOrders.completed.description" />
                        :
                    </b>
                    {{ formatDate(order.date) }}
                </div>
                <div class="status-text">
                    <b><i18n-t keypath="dashboard.myAccountComponent.companyInfoTab.teamMembers.payment_received"/>:</b>
                    {{ formatDate(order.date) }}
                </div>
                <div class="status-text">
                    <b>CMR:</b>
                    {{ formatDate(order.date) }}
                </div>
            </div>
        </td>
        <!-- <th
            class="dashboard__table-th dashboard__table-sorting"
            v-if="['3', '4', '5'].includes(orderStatus)"
        ></th> -->
        <td class="dashboard__table-td pr-0">
            <div class="dashboard__popup-item dashboard__carInfo-item c-orders-item-line">
                <span
                    class="
                        dashboard__table-text dashboard__normal
                        c-table-body-font-12 c-bold
                    "
                >
                    <strong>{{ formatDate(order?.date) }}</strong>
                    <br />
                </span>
            </div>
        </td>
        <td class="dashboard__table-td c+size-345">
            <div
                class="dashboard__popup-item dashboard__carInfo-item c-orders-item-line"
                style="border: none"
            >
                <div class="dashboard__table-column">
                    <div class="c-order-item-car-info">
                        <div class="dashboard__carInfo-info">
                            <span
                                class="
                                    dashboard__table-text dashboard__normal
                                    c-table-body-font-12
                                "
                            >
                                <template v-for="text of order?.description" :key="text">
                                    {{ text }}
                                    <br />
                                </template>
                            </span>
                            <span
                                v-if="order?.customer_reference"
                                class="
                                    dashboard__table-text dashboard__normal
                                    c-table-body-font-12 c-margin-6
                                "
                            >
                                <strong>
                                    <i18n-t keypath="cart.customerReference" />
                                    :
                                </strong>
                                {{ order.customer_reference }}
                            </span>
                            <span
                                class="
                                    dashboard__table-text dashboard__normal
                                    c-table-body-font-12 c-margin-6
                                "
                            >
                                <strong>
                                    <i18n-t
                                        keypath="dashboard.myAccountComponent.companyInfoTab.teamMembers.power_user"
                                    />
                                </strong>
                                {{ order.purchase_contact.firstname }}
                                {{ order.purchase_contact.lastname }}
                            </span>
                            <span
                               v-if="
                                    orderStatus !== String('to_approve') &&
                                    orderStatus !== '1'
                                "
                                class="
                                    dashboard__table-text dashboard__normal
                                    c-table-body-font-12 c-margin-6
                                "
                            >
                                <strong>
                                    <i18n-t keypath="dashboard.myAccountComponent.companyInfoTab.teamMembers.approver"/>
                                </strong>
                                {{ order.purchase_contact.firstname }}
                                {{ order.purchase_contact.lastname }}
                            </span>
                            <span
                                class="
                                    dashboard__table-text dashboard__normal
                                    c-table-body-font-12
                                "
                                :class="
                                    isOrderInStatus(orderStatusEnum.to_approve)
                                        ? 'c-margin-6'
                                        : 'c-margin-3'
                                "
                                style="margin-top: 6px"
                            >
                                <strong>
                                    <i18n-t
                                        keypath="dashboard.myAccountComponent.orderDeliveryLocation"
                                    />
                                </strong>
                                {{ order?.delivery_address.street }}
                                {{ order?.delivery_address.number }} ,
                                {{ order?.delivery_address.zipcode }} ,
                                {{ order?.delivery_address.country?.name }}
                            </span>
                            <span
                                class="
                                    dashboard__table-text dashboard__normal
                                    c-table-body-font-12
                                "
                                :class="
                                    isOrderInStatus(orderStatusEnum.to_approve)
                                        ? 'c-margin-6'
                                        : 'c-margin-3'
                                "
                            >
                                <strong>
                                    <i18n-t
                                        keypath="dashboard.myAccountComponent.transportType"
                                    />
                                </strong>
                                {{ order.transport_expeditor.name }}
                            </span>
                            <span
                                class="
                                    dashboard__table-text dashboard__normal
                                    c-table-body-font-12
                                "
                                :class="
                                    isOrderInStatus(orderStatusEnum.to_approve)
                                        ? 'c-margin-6'
                                        : 'c-margin-3'
                                "
                            >
                                <strong>
                                    <i18n-t
                                        keypath="dashboard.myAccountComponent.contactInfoTab.orderUserid"
                                    />
                                </strong>
                                {{ order?.id }}
                            </span>
                            <div class="flex">
                                <span
                                    class="
                                        dashboard__table-text dashboard__normal
                                        c-table-body-font-12
                                    "
                                    :class="
                                        isOrderInStatus(orderStatusEnum.to_approve)
                                            ? 'c-margin-6'
                                            : 'c-margin-3'
                                    "
                                >
                                    <strong>
                                        <i18n-t
                                            keypath="dashboard.myAccountComponent.proformaNumber"
                                        />
                                        {{ " " }}
                                    </strong>
                                    <span v-if="order?.backoffice_reference">
                                        {{ order.backoffice_reference }}
                                    </span>
                                    <span v-else>
                                        <i18n-t keypath="myOrders.notYetAvailable" />
                                    </span>
                                </span>
                                <img
                                    v-if="!(order.status.id === 1) && isEye"
                                    width="16"
                                    height="16"
                                    src="/img/Vector.svg"
                                    class="eye"
                                    @click="viewProformaOrder = order"
                                />
                            </div>
                            <!--                            <div-->
                            <!--                                v-if="-->
                            <!--                                    orderStatus === String('to_pay') ||-->
                            <!--                                    orderStatus === '3'-->
                            <!--                                "-->
                            <!--                            >-->
                            <!--                                <div-->
                            <!--                                    style="-->
                            <!--                                        width: 324px;-->
                            <!--                                        height: 26px;-->
                            <!--                                        margin-top: 6px;-->
                            <!--                                        display: flex;-->
                            <!--                                        justify-content: space-between;-->
                            <!--                                    "-->
                            <!--                                >-->
                            <!--                                    <span-->
                            <!--                                        style="-->
                            <!--                                            text-align: right;-->
                            <!--                                            font-size: 12px;-->
                            <!--                                            font-weight: 400;-->
                            <!--                                            line-height: 18px;-->
                            <!--                                            letter-spacing: 0;-->
                            <!--                                        "-->
                            <!--                                    >-->
                            <!--                                        Truck load-->
                            <!--                                    </span>-->
                            <!--                                    <span-->
                            <!--                                        style="-->
                            <!--                                            font-size: 12px;-->
                            <!--                                            font-weight: 600;-->
                            <!--                                            line-height: 18px;-->
                            <!--                                            letter-spacing: 0;-->
                            <!--                                        "-->
                            <!--                                    >-->
                            <!--                                        <img-->
                            <!--                                            width="27"-->
                            <!--                                            height="14"-->
                            <!--                                            src="/img/Group.svg"-->
                            <!--                                        />-->
                            <!--                                        x {{ this.trackCount }}-->
                            <!--                                    </span>-->
                            <!--                                </div>-->
                            <!--                                <div class="progress-container">-->
                            <!--                                    <div-->
                            <!--                                        class="progress-bar"-->
                            <!--                                        :style="{-->
                            <!--                                            width: getTrackLoadPercent(),-->
                            <!--                                        }"-->
                            <!--                                    />-->
                            <!--                                </div>-->
                            <!--                            </div>-->
                        </div>
                    </div>
                </div>
            </div>
        </td>
        <td class="dashboard__table-td c+size-142" style="overflow: visible">
            <vue-tippy
                interactive
                placement="right"
                animation="shift-away"
                trigger="mouseenter focus"
                :hideOnClick="false"
                tag="div"
                :arrow="true"
                theme="light"
                :update-on-content-resize="true"
            >
                <div
                    class="
                        dashboard__popup-item
                        dashboard__carInfo-item
                        dashboard__carInfo-item--center
                        c-orders-item-line
                    "
                >
                    <span
                        class="
                            dashboard__table-text dashboard__normal
                            c-table-body-font-12 c-bold
                        "
                    >
                        <strong>{{ order.vehicle_counter }}</strong>
                    </span>
                </div>
                <template #content>
                    <div class="tooltip-content">
                        <div
                            class="tooltip-content-element"
                            v-for="orderVehicle of orderVehicles"
                            :key="orderVehicle.id.toString()"
                        >
                            <div class="image-container">
                                <img
                                    v-if="orderVehicle?.thumbnail_image?.href_small"
                                    :src="orderVehicle.thumbnail_image?.href_small"
                                />
                                <div class="no-image-block" :class="noImageBlockClassName" v-else>
                                    <img
                                        style="height: 60%"
                                        :src="`/img/${brandLabel}/no-image.svg`"
                                    />
                                </div>
                            </div>
                            <div class="text-container">
                                <b>
                                    {{
                                        `${orderVehicle?.vehicle?.brand?.name} ${orderVehicle?.vehicle?.model}`
                                    }}
                                </b>
                                <br />
                                {{ orderVehicle.vehicle.powertrain.motorisation }}
                                {{
                                    orderVehicle?.vehicle?.firstregistration_date
                                        ? " / " +
                                          formatDate(
                                              orderVehicle?.vehicle
                                                  ?.firstregistration_date,
                                              "yyyy",
                                          )
                                        : ""
                                }}
                                <br />
                                <b>
                                    <app-format-currency
                                        :value="orderVehicle?.price_vehicle_ex_vat ?? 0"
                                        currency="EUR"
                                    ></app-format-currency>
                                </b>
                            </div>
                        </div>
                    </div>
                </template>
            </vue-tippy>
        </td>
        <td class="dashboard__table-td c+size-161">
            <div class="c-orders-item-line-last" />
            <div class="dashboard__popup-column dashboard__popup-price c-price-details">
                <div class="dashboard__popup-priceBlock">
                    <strong>
                        <i18n-t keypath="cart.vehicles" />
                    </strong>
                    <strong class="text-right">
                        <app-format-currency
                            :value="orderPriceDetailDto?.total_price_vehicles_ex_vat ?? 0"
                            currency="EUR"
                        ></app-format-currency>
                    </strong>
                </div>
                <div class="dashboard__popup-priceBlock">
                    <strong>
                        <i18n-t keypath="cart.transportFees" />
                    </strong>
                    <strong class="text-right">
                        <app-format-currency
                            :value="
                                orderPriceDetailDto?.total_price_transport_ex_vat ?? 0
                            "
                            currency="EUR"
                        ></app-format-currency>
                    </strong>
                </div>
                <div class="dashboard__popup-priceBlock">
                    <strong>
                        <i18n-t keypath="cart.adminFees" />
                    </strong>
                    <strong class="text-right">
                        <app-format-currency
                            :value="
                                orderPriceDetailDto?.total_price_admin_handling_ex_vat ??
                                0
                            "
                            currency="EUR"
                        ></app-format-currency>
                    </strong>
                </div>
                <div class="dashboard__popup-priceBlock">
                    <strong>
                        <i18n-t keypath="cart.vat" />
                    </strong>
                    <strong
                        class="text-right"
                        v-if="orderPriceDetailDto?.total_vat_amount != undefined"
                    >
                        <app-format-currency
                            :value="orderPriceDetailDto?.total_vat_amount ?? 0"
                            currency="EUR"
                        ></app-format-currency>
                    </strong>
                    <strong class="text-right" v-else>TBD</strong>
                </div>
                <div class="dashboard__popup-priceBlock"">
                    <strong>
                        <i18n-t keypath="cart.dealReduction" />
                    </strong>
                    <strong class="text-right">
                        <app-format-currency
                            :value="(orderPriceDetailDto?.deal_reduction > 0 ? -orderPriceDetailDto?.deal_reduction : 0)"
                            currency="EUR"
                        ></app-format-currency>
                    </strong>
                </div>
                <div class="line"></div>
                <hr style="width: 100%; background: #283747" />
                <div class="dashboard__popup-priceBlock">
                    <strong>
                        <i18n-t keypath="cart.subtotal" />
                    </strong>
                    <strong class="text-right">
                        <app-format-currency
                            v-if="
                                orderPriceDetailDto?.total_price_including_vat !=
                                undefined
                            "
                            :value="orderPriceDetailDto.total_price_including_vat"
                            currency="EUR"
                        ></app-format-currency>
                        <template v-else>TBD</template>
                    </strong>
                </div>
            </div>
        </td>
        <td
            class="dashboard__table-td"
            :class="`${
                showDocuments && (orderStatus === '4' || orderStatus === '5')
                    ? 'c-size-220'
                    : 'c-size-117'
            }`"
        >
            <div class="dashboard__table-column dashboard__table-column--stretch">
                <template v-if="true">
                    <button
                        v-if="
                            !showDocuments &&
                            (orderStatus === String('to_pay') || orderStatus === '3')
                        "
                        class="dashboard__table-btn gray"
                        type="button"
                        @click="redirectToOrderDetailsAvailable(orderStatus)"
                    >
                        <i18n-t keypath="myOrders.pay" />
                    </button>
                    <button
                        v-if="
                            openPayAllButton &&
                            (orderStatus === String('to_pay') || orderStatus === '3')
                        "
                        class="dashboard__table-btn gray"
                        type="button"
                        @click="showPayAllPopup"
                    >
                        <i18n-t keypath="cart.payAll" />
                    </button>
                    <button
                        v-if="(orderStatus === 'to_transport') && openPickupDateButton"
                        class="dashboard__table-btn"
                        type="button"
                        @click="redirectToOrderDetailsAvailable(orderStatus)"
                        style="background: rgba(91, 114, 218, 1)"
                    >
                        <i18n-t keypath="cart.pickupDate" />
                    </button>
                    <div
                        v-if="orderStatus === '4' && openPickupDateButton"
                        style="width: 100%"
                    >
                        <p-calendar
                            style="position: absolute; opacity: 0; height: 1.875rem"
                            id="range"
                            :input-style="'cursor: pointer'"
                            :min-date="new Date(Date.now() + 48 * 60 * 60 * 1000)"
                            :max-date="new Date(Date.now() + 15 * 24 * 60 * 60 * 1000)"
                            dateFormat="dd/mm/yy"
                            selectionMode="range"
                            :manualInput="false"
                            v-if="showDatePicker"
                            @update:modelValue="handleDateSelected"
                        />
                        <button
                            class="dashboard__table-btn"
                            type="button"
                            @click="getDatePicker()"
                            style="background: rgba(91, 114, 218, 1)"
                        >
                            <i18n-t keypath="cart.pickupDateForAll" />
                        </button>
                    </div>
                    <ConfirmDatePopup
                        v-if="showConfirmPopup"
                        v-model:_vehiclesId="vehicleIds"
                        v-model:_order="order"
                        v-model:_formattedDate="formattedSelectedDate"
                        @closeConfirmPopup="closeConfirmPopup"
                    />
                    <button
                        v-if="
                            (orderStatus === String('to_approve') ||
                                orderStatus === '1') &&
                            order.status.id === 3
                        "
                        class="dashboard__table-btn"
                        type="button"
                        @click="approveOrder(order)"
                        style="background: var(--color-primary)"
                    >
                        <i18n-t keypath="myOrders.approve" />
                    </button>
                    <button
                        v-if="
                            (orderStatus === 'processing_documents' &&
                                openProcessingDocInfo) ||
                            (orderStatus === '5' &&
                                openProcessingDocInfo &&
                                !showDocuments)
                        "
                        class="dashboard__table-btn"
                        type="button"
                        @click="redirectToOrderDetailsAvailable(orderStatus)"
                        style="background: rgba(249, 198, 17, 1)"
                    >
                        Upload CMR
                    </button>
                    <button
                        v-if="
                            orderStatus === '5' && openProcessingDocInfo && showDocuments
                        "
                        class="dashboard__table-btn"
                        type="button"
                        @click="() => (showUploadCmr = true)"
                        style="background: rgba(249, 198, 17, 1)"
                    >
                        UPLOAD CMR FOR ALL
                    </button>
                    <a
                        v-if="
                            (orderStatus === String('to_approve') ||
                                orderStatus === '1') &&
                            order.status.id === 3
                        "
                        class="dashboard__table-link"
                        title="Decline"
                        style="text-decoration: underline"
                        @click="openDecline(order.id)"
                    >
                        <svg
                            class="sprite-icon dashboard__table-icon"
                            width="18"
                            height="18"
                        >
                            <use xlink:href="/img/sprite.svg#decline"></use>
                        </svg>
                        <span>
                            <i18n-t keypath="myOrders.to_approve.decline" />
                        </span>
                    </a>
                </template>
                <template
                    v-if="orderStatus === String('on_order') || orderStatus === '2'"
                ></template>
                <router-link
                    v-if="!showDocuments"
                    class="dashboard__table-link"
                    :to="{
                        path: `/auth/my-carconnex/my-orders/${orderStatus}/order-details/${order.id}`,
                    }"
                    @click.prevent="() => redirectToOrderDetails"
                >
                    <img width="18" height="18" src="/img/list.svg" alt="#" />
                    <span style="margin-left: 12px">
                        <i18n-t keypath="myOrders.viewOrderDetails" />
                    </span>
                </router-link>
                <router-link
                    v-if="orderStatus === String('to_pay') || orderStatus === '3'"
                    class="dashboard__table-link"
                    to=""
                    @click="openPaymentsTransactionsPopup(order.id)"
                >
                    <img width="18" height="18" src="/img/payment.svg" alt="#" />
                    <span style="margin-left: 12px">View payment</span>
                </router-link>
                <template
                    v-if="(orderStatus === String('to_transport')) && openPickupDateButton"
                >
                    <span class="c-pickup-hours-label">
                        <b><i18n-t keypath="myOrders.pickupHours" />:</b>
                        08:00 - 16:00
                    </span>
                </template>
            </div>
            <div
                class="dashboard__table-badge table-badge"
                :class="
                    order.type.id === 1 ? 'table-badge--online' : 'table-badge--offline'
                "
            >
                <svg class="sprite-icon dashboard__table-icon" width="12" height="12">
                    <use xlink:href="/img/sprite.svg#icon-credit"></use>
                </svg>
                <span class="table-badge__text">
                    {{ order.type.id === 1 ? "online" : "key account" }}
                </span>
            </div>
        </td>
    </tr>
    <order-vehicle-table
        v-if="showDocuments"
        :order="order"
        :orderVehicles="orderVehicles"
        :orderStatus="orderStatus"
        v-model:_selectedCars="selectedCars"
        v-model:_isPaymentsTransactionsPopup="isPaymentsTransactionsPopup"
        v-model:_orderPaymentDto="orderPaymentDto"
        v-model:_orderId="orderId"
        :fetchOrders="fetchOrders"
    />
    <upload-cmr-popup
        @closePopup="closeUploadCmr"
        v-if="showUploadCmr"
        v-model:_orderId="order.id"
        v-model:_vehiclesId="vehicleIds"
    />
    <manual-transfer-popup
        @close="() => (showPay = false)"
        v-if="showPay"
        v-model:_orderId="order.id"
        v-model:_vehiclesId="vehicleIds"
        v-model:_isProcessingPayment="everyVeInProcessingPayments"
    />
</template>

<script lang="ts">
import { TableItem } from "@/dashboard/my-orders/orders-table/table-item/table-item";

export default TableItem;
</script>
<style scoped lang="scss">
@import "public/css/utils/vars.scss";
@import "public/css/utils/mixins.scss";
@import "public/css/utils/utils.scss";
.gray {
    background: var(--color-green);
}
.tooltip-content {
    display: flex;
    flex-direction: column;
    gap: c-rem(10);
    max-height: c-rem(520);
    overflow-y: scroll;
}
.tooltip-content-element {
    display: flex;
    flex-direction: row;
    align-items: stretch;
    gap: c-rem(16);
    border-bottom: 1px solid $color-gray-soft;
}
.image-container {
    flex: 1;
}
.to-pay-status {
    height: 24px;
    white-space: nowrap;
    border-radius: 4px;
    border: 1px solid var(--color-green);
    font-size: 10px;
    font-weight: 600;
    line-height: 15px;
    letter-spacing: 0;
    text-align: center;
    background: white;
    color: var(--color-green);
    margin-top: 15px;
    text-transform: uppercase;
}
.image-container img {
    height: 100%;
    width: auto;
}
.text-container {
    flex: 1;
}
.no-image-block {
    background: var(--light-gray);
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
}
.no-image-block.astara {
    background: #E4E4E4;
}
:global(.tippy-box) {
    min-width: c-rem(300);
}
@import "table-item";
</style>
